import *
    as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, useHistory, useLocation } from 'react-router';
import { Button, Card, CardBody, CardHeader, Col, Collapse, Container, Form, Input, Row, Spinner, ButtonToggle } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ApplicationState } from '../../store';
import * as SessionMdl from '../../models/SessionModel';
import { LoadingIcon } from '../Misc/Loading';
import { SaCurrency, SaDate, SaLabel } from '../Misc/SawinComponents';
import { useEffect, useState } from 'react';
import * as CustomerRequestStore from '../../store/CustomerRequest';
import * as CustomerRequestMdls from '../../models/CustomerRequestBucket';
import * as CustomerRequestInitialDataStore from '../../store/CustomerRequestInitialData';
import * as CustomerRequestInitialDataMdls from '../../models/CustomerRequestInitialData';
import '../../../node_modules/cleave.js/dist/addons/cleave-phone.us'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
const Cleave = require('../../../node_modules/cleave.js/react');
//import Cleave from 'cleave.js';


type MyProps =
    { SessionState: SessionMdl.SessionModel, RequestState: CustomerRequestMdls.CustomerRequestBucketModel, InitialData: CustomerRequestInitialDataMdls.CustomerRequestInitialData } & typeof CustomerRequestStore.actionCreators & typeof CustomerRequestInitialDataStore.actionCreators;

const CustomerRequest: React.FunctionComponent<MyProps> = (props: MyProps) => {

    const history = useHistory();

    var todayPlus45: Date = new Date();
    todayPlus45.setDate(new Date().getDate() + props.SessionState.SelectedAR.numOfDaysToRequestService);    

    const [CustomerRequestLocal, updateCustomerRequestInfo] = useState<CustomerRequestMdls.CustomerRequestBucketModel>({ ...CustomerRequestMdls.initialState, serviceOrProposal: "S" });

    //used to fill Categories buttons
    const [distinctCategories, updateDistinctCategories] = useState<string[]>([]);

    //used to fill Ins
    const [filteredTaskCode, updateFilteredTaskCode] = useState<CustomerRequestInitialDataMdls.CustomerRequestTaskInfoItem[]>([]);

    const [localPromissedTimeOptions, updatePromissedTimeOptions] = useState<CustomerRequestInitialDataMdls.CustomerRequestInitialDataTimePromissed[]>([]);

    useEffect(() => {
        if (props.RequestState.success == 'Y') {
            //history.replace(`Request/${requestState.ServiceType}`);
            history.goBack();
            props.resetState();
        }
        if (props.RequestState.error) {
            alert(props.RequestState.error);
        }

        const distinct = (value: string, index: number, self: string[]) => {
            return self.indexOf(value) === index;
        }

        const distinctCategories: string[] = props.InitialData.items.taskInfoList.map(x => x.category).filter(distinct);

        updateDistinctCategories(distinctCategories);

    }, [props]);

    useEffect(() => {
        updatePromissedTimeOptions([]);
        props.loadTaskInfo();
    }, []);

    useEffect(() => {
        var tmp = props.InitialData.items.taskInfoList.filter((value, index, array) => {
            return value.category == CustomerRequestLocal.taskCategory;
        });
        updateFilteredTaskCode(tmp);
        if (tmp.length > 0) {
            updateCustomerRequestInfo({ ...CustomerRequestLocal, ...{ taskCode: `${tmp[0].funcionCode}.${tmp[0].componentCode}` } });
        }

    }, [CustomerRequestLocal.taskCategory]);

    useEffect(() => {
        updatePromissedTimeOptions([]);
        if (CustomerRequestLocal.requestDate && CustomerRequestLocal.taskCode) {
            props.loadInitialData(CustomerRequestLocal.requestDate, CustomerRequestLocal.taskCode, 'S');
        }
    }, [CustomerRequestLocal.taskCode, CustomerRequestLocal.requestDate]);

    useEffect(() => {
        if (CustomerRequestLocal.requestDate && CustomerRequestLocal.taskCode) {
            updatePromissedTimeOptions(props.InitialData.items.timePromissedOptions);
        }
    }, [props.InitialData.items.timePromissedOptions]);

    const SubmitEvent = (e: React.FormEvent) => {
        e.preventDefault();
        props.request(CustomerRequestLocal);
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
        e.preventDefault();
        var valueChanged = { [e.target.id]: e.target.value };
        updateCustomerRequestInfo({ ...CustomerRequestLocal, ...valueChanged });
    }

    const handleTaskCategoryChange = (e: any) => {
        e.preventDefault();
        var valueChanged = { [e.target.id]: e.target.value };
        updateCustomerRequestInfo({ ...CustomerRequestLocal, ...valueChanged });
    }

    const handlePromissedTime = (e: any) => {
        e.preventDefault();
        updateCustomerRequestInfo({ ...CustomerRequestLocal, ...{ requestedTime: e.target.value } });
    }

    const handleDateChange = (e: any) => {
        updateCustomerRequestInfo({ ...CustomerRequestLocal, requestDate: e });
    }

    const handleCleveChange = (e: any) => {
        e.preventDefault();
        var valueChanged = { [e.target.id]: e.target.rawValue };
        updateCustomerRequestInfo({ ...CustomerRequestLocal, ...valueChanged });

    }

    const RequestBtn = () => {
        if (!props.RequestState.processing) {
            return (<input type="submit" value="Submit" className="btn btn-success" id="RequestBtn" name="RequestBtn" />);
        } else {
            return (<span>Loading<Spinner size="sm" color="primary" /></span>);
        }
    }

    return (
        <Container fluid={true}>
            <LoadingIcon loading={props.InitialData.loading} title={props.SessionState.SelectedSM.id + " - " + props.SessionState.SelectedSM.name.displayName} address={props.SessionState.SelectedSM.address} />
            {<Form onSubmit={SubmitEvent}>
                <Card className="customer_request-card">
                    <CardHeader className="center-align">
                        {props.SessionState.SelectedSM.address.line1} WhiteBoard {props.SessionState.SelectedAR.useWhiteBoard}
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col xs={12}>
                                <SaLabel Text={"Contact Name"} />
                                <input type="text" required onChange={handleChange} className="form-control" key="contactName" id="contactName" name="contactName" value={CustomerRequestLocal.contactName} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <SaLabel Text={"Phone #"} />
                                <Cleave
                                    required
                                    options={{
                                        uppercase: true,
                                        //delimiters: [' ', ' '],
                                        blocks: [3, 3, 4],
                                        numericOnly: true
                                    }} className="form-control"
                                    onChange={handleCleveChange}
                                    key="contactPhone" id="contactPhone" name="contactPhone"
                                    value={CustomerRequestLocal.contactPhone}
                                />
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <Card className="customer_request-card-inner">
                    <CardBody>
                        <Row>
                            <Col xs={12} style={{ display: "flex", flexWrap: 'wrap', justifyContent: 'space-evenly' }}>                                
                                {distinctCategories.map((item, index) => {
                                    return (item == CustomerRequestLocal.taskCategory ?
                                        <Button type={'button'} style={{ margin: '5px' }} name="taskCategory" id="taskCategory" onClick={handleTaskCategoryChange} key={index} color={"success"} value={item}>{item}</Button>
                                        :
                                        <Button className={'customer_request-btn-noSelected'} type={'button'} style={{ margin: '5px' }} name="taskCategory" id="taskCategory" onClick={handleTaskCategoryChange} key={index} value={item}>{item}</Button>);                                       
                                }                                    
                                    //<Button active style={{ margin: '5px' }} name="taskCategory" id="taskCategory" onClick={handleTaskCategoryChange} key={index} color="success" value={item}>{item}</ButtonToggle>
                                )}
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                {CustomerRequestLocal.taskCategory &&
                    <Card className="customer_request-card-inner">
                        <CardBody>
                            <Row>
                                <Col xs={12}>
                                    <SaLabel Text={"Issue"} />
                                    <Input type="select" id="taskCode" name="taskCode" value={CustomerRequestLocal.taskCode} onChange={handleChange}>
                                        {filteredTaskCode &&
                                            filteredTaskCode.map(function (item, index) {
                                                var TaskCodeKey = `${item.funcionCode}.${item.componentCode}`;
                                                return <option key={TaskCodeKey} value={TaskCodeKey}>{item.description}</option>;
                                            })
                                        }
                                    </Input>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <SaLabel Text={"Detail Description"} />
                                    <textarea required rows={3} onChange={handleChange} className="form-control" key="descriptionOfWork" id="descriptionOfWork" name="descriptionOfWork" value={CustomerRequestLocal.descriptionOfWork} />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                }

                {CustomerRequestLocal.taskCode &&
                    <Card className="customer_request-card-inner">
                        <CardBody>
                            <Row>
                                <Col xs={12}>
                                    <SaLabel Text={"Prefered Date"} />
                                    <DatePicker className="form-control"
                                        id="requestDate" name="requestDate"
                                        minDate={new Date()}
                                        maxDate={todayPlus45}
                                        selected={CustomerRequestLocal.requestDate}
                                        onChange={handleDateChange} />
                                </Col>
                            </Row>
                            {localPromissedTimeOptions.length > 0 &&
                                <Row>
                                    <Col xs={12} style={{ display: "flex", flexWrap: 'wrap', justifyContent: 'space-evenly' }}>
                                        {localPromissedTimeOptions.map(function (item, index) {
                                            if (item.isAvailable) {
                                                if (item.code == CustomerRequestLocal.requestedTime) {
                                                    return (<Button type={'button'} style={{ margin: "5px" }} onClick={handlePromissedTime} key={index} color={"success"} value={item.code}>{item.description}</Button>);
                                                } else {
                                                    return (<Button className={'customer_request-btn-noSelected'} type={'button'} style={{ margin: "5px" }} onClick={handlePromissedTime} key={index} value={item.code}>{item.description}</Button>);
                                                }                                                
                                            } else {
                                                return (<Button type={'button'} style={{ margin: "5px" }} disabled key={index} color="danger" value={item.code}>{item.description}</Button>);
                                            }
                                        }
                                        )}
                                    </Col>
                                </Row>
                            }
                        </CardBody>
                    </Card>
                }

                {props.InitialData.items.serviceRequestMessage &&
                    <Card className='customer_request-message-card'>
                        <CardBody>
                            <div dangerouslySetInnerHTML={{ __html: props.InitialData.items.serviceRequestMessage }}  ></div>
                        </CardBody>
                    </Card>
                }
                {CustomerRequestLocal.requestedTime &&
                <Card className='customer_request-btn-card'>
                    <CardBody>
                        <RequestBtn />
                    </CardBody>
                    </Card>
                }
            </Form>
            }

        </Container>
    );
}

export default connect((state: ApplicationState) =>
({
    ...{
        RequestState: state.customerRequestState,
        InitialData: state.customerRequestInitialDataState,
        SessionState: state.sessionState
    }
}),
    { ...CustomerRequestStore.actionCreators, ...CustomerRequestInitialDataStore.actionCreators })(CustomerRequest as any);